import { cn } from '@/shared/utils';
import { CustomTooltip } from '@/view/shared/Tooltip';
import { type TrialBannerTone, useTrialClockViewModel } from '@/viewmodel/features/quota';
import { Clock, Lock } from 'lucide-react';
import type { ReactNode } from 'react';

const TONE_CLASS: Record<TrialBannerTone, string> = {
  info: 'border-primary/30 text-primary hover:bg-primary/10',
  warning: 'border-warning/40 text-warning hover:bg-warning/10',
  danger: 'border-destructive/40 text-destructive hover:bg-destructive/10',
};

export function TrialClock(): ReactNode {
  const clock = useTrialClockViewModel();

  if (!clock) return null;
  const Icon = clock.expired ? Lock : Clock;

  return (
    <CustomTooltip tip={clock.tip} placement="bottom">
      <button
        type="button"
        data-testid="trial-clock"
        onClick={clock.onPress}
        className={cn(
          'inline-flex h-8 shrink-0 cursor-pointer items-center gap-1.5 rounded-full border bg-surface px-2.5 font-mono text-2xs uppercase tracking-wider transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-border',
          TONE_CLASS[clock.tone],
        )}
      >
        <Icon size={13} />
        <span>{clock.label}</span>
      </button>
    </CustomTooltip>
  );
}
